<template>
  <div class="container mx-auto p-5 xl:h-screen">
    <div class="flex flex-wrap items-center gap-2 mb-2">
      <h1 class="text-lg font-medium leading-6 text-gray-900 mr-2 uppercase">Disclosure & Billing DETAILS</h1>
      <button
        @click="editDetails(true)"
        type="button"
        class="mb-2 inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <i class="fa fa-pencil-square-o mr-1 w-4" aria-hidden="true"></i>
        Edit Details
      </button>
    </div>
    <hr />
    <div class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-[#1f3341]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <div class="text-sm text-[#1f3341]">
            <div>Please note: If you have been receiving direct deposit from us, rest assured that your billing information is on file with us and may not be displayed here.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-wrap md:-mx-2 mt-4">
      <div class="w-full mx-2 flex">
        <div class="bg-white w-full p-3 shadow-md rounded-sm border-2">
          <div class="xl:grid grid-cols-2 md:grid grid-cols-2">
            <ul class="list-inside space-y-1 px-1">
              <li class="xl:mb-10">
                <div
                  class="text-teal-600 w-5/6"
                >Have any complaints been filed against you with any disciplinary authority within the last five(5) years?</div>
                <div class="text-gray-500 text-md">
                  <span
                    v-if="profile_data.complaint_detail!='' && profile_data.complaint_detail!=null"
                  >Yes</span>
                  <span
                    v-if="profile_data.complaint_detail=='' || profile_data.complaint_detail==null"
                  >No</span>
                </div>
              </li>
              <li>
                <div class="text-teal-600">SSN/EIN</div>
                <div class="text-gray-500 text-md">{{ maskSSNEIN(profile_data.social_security,profile_data.number_type) }}</div>
              </li>
              <li>
                <div class="text-teal-600">Payment Method</div>
                <div class="text-gray-500 text-md">
                  <div v-if="profile_data.direct_deposite">
                    <span v-if="profile_data.direct_deposite==1">Direct Deposit</span>
                    <span v-if="profile_data.direct_deposite!=1">Check</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="text-teal-600">Payable To</div>
                <div class="text-gray-500 text-md">{{ profile_data.pay_to }}</div>
              </li>
              <li>
                <div class="text-teal-600">Pay-To Address</div>
                <div
                  class="text-gray-500 text-md"
                  v-if="
                      profile_data.pay_address_1 != null &&
                        profile_data.pay_address_1 != ''
                    "
                >
                  <p>{{ profile_data.pay_address_1 }},</p>
                  <p
                    v-if="
                      profile_data.pay_address_2 != null &&
                        profile_data.pay_address_2 != ''
                    "
                  >{{ profile_data.pay_address_2 }},</p>
                  <p>{{ profile_data.pay_city }} - {{ profile_data.pay_zip }},</p>
                  <p>{{ profile_data.pay_county }}, {{ profile_data.pay_state }}</p>
                </div>
              </li>
            </ul>
            <ul class="list-inside space-y-1">
              <li
                class="xl:mb-16"
                v-if="profile_data.complaint_detail!='' && profile_data.complaint_detail!=null"
              >
                <div class="text-teal-600">Complaint Detail</div>
                <div class="text-gray-500 text-md">{{ profile_data.complaint_detail }}</div>
              </li>
              <li>
                <div class="text-teal-600">Account Holder Name</div>
                <div class="text-gray-500 text-md">{{ profile_data.account_holder }}</div>
              </li>
              <li>
                <div class="text-teal-600">Bank Name</div>
                <div class="text-gray-500 text-md">{{ profile_data.bank_name }}</div>
              </li>
              <li>
                <div class="text-teal-600">Checking or Savings</div>
                <div class="text-gray-500 text-md">{{ profile_data.checking_saving }}</div>
              </li>
              <li>
                <div class="text-teal-600">Routing #</div>
                <div class="text-gray-500 text-md">{{ profile_data.routing_number }}</div>
              </li>
              <li>
                <div class="text-teal-600">Account #</div>
                <div class="text-gray-500 text-md">{{ profile_data.account_number }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="my-4"></div>
      </div>
    </div>
    <div id="disclosure_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-4/5 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-2 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1">Edit Details</p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="editDetails(false)"></i>
            </div>
            <div class="flex flex-col">
              <app-disclosure class="editprofile-popup-scroll" :forms="form" ref="child_comp_3"></app-disclosure>
              <button
                type="button"
                @click="updateAttorney()"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <i class="fa fa-pencil-square-o mr-1 mt-1" aria-hidden="true"></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppDisclosure from "./AppDisclosure.vue"; // importing resuable input field
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery";
export default {
  name: "DisclosureDetails",
  props: ["forms"],
  data: function() {
    // declaring static variable for this component
    return {
      form: this.forms
    };
  },
  // use to import central level variables from store
  computed: mapState(["profile_data"]),
  //importing resuable components to use in current component
  components: {
    AppDisclosure
  },
  methods: {
    updateAttorney: function() {
      this.$refs["child_comp_3"].submitApplication();
      if (
        this.$refs["child_comp_3"].v$.form.$pending ||
        this.$refs["child_comp_3"].v$.form.$error
      ) {
        this.$toast.error("please fill required fields!");
        return;
      }
      const updatedData = {
        ...this.form,
        update_key: "UPDATE_DISCLOSURE_AND_BILLING",
      };
      delete updatedData.addresses;
      delete updatedData.contacts;
      this.$store.dispatch("updateAttorneyData", {
        data: updatedData,
      });
      console.log(this.form);
    },
    editDetails: function(value) {
      $("#disclosure_detail div").animate({ scrollTop: 0 }, 1000);
      if (value) {
        document.getElementById("disclosure_detail").classList.remove("hidden");
      } else {
        document.getElementById("disclosure_detail").classList.add("hidden");
        this.$store.dispatch("getAttProfileData");
      }
    },
    maskSSNEIN(value, type) {
      if (!value) return '';
      const cleaned = value.toString().replace(/\D/g, '');

      if (type === 'ssn' && cleaned.length >= 4) {
        return '***-**-' + cleaned.slice(-4);
      } else if (type === 'ein' && cleaned.length === 9) {
        return cleaned.slice(0, 2) + '-' + cleaned.slice(2);
      }
      return value;
    }
  }
};
</script>
